<template>
<div class="comm_scr_wrap">
    <div class="row">
        <div class="col-xs-1">
            <sui-input-label label="default" required/>
        </div>
        <div class="col-xs-3">
            <sui-text-field max-length="100" placeholder="input any text" default/>
            <div class="comp_spacing" />
            <button class="comm_btn_duplicate" title="check duplicates"/>
        </div>
        <div class="col-xs-1">
            <sui-input-label label="currency"/>
        </div>
        <div class="col-xs-3">
            <sui-text-field default mask="currency"/>
            <div class="comp_spacing" />
            <button class="btn_innerTbl_border">추가</button>
        </div>
        <div class="col-xs-1">
            <sui-input-label label="다국어"/>
        </div>
        <div class="col-xs-3">
            <sui-text-field placeholder="한국어 입력" default clearable/>
            <div class="comp_spacing" />
            <sui-text-field placeholder="영어 입력"   default clearable/>
            <div class="comp_spacing" />
            <button class="comm_btn_lang">다국어버튼</button>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-1">
            <sui-input-label label="검색"  :vertical="false"/>
        </div>
        <div class="col-xs-3">
            <sui-text-field v-model="pageName" clearable fixed-icon />
        </div>
        <div class="col-xs-1">
            <sui-input-label label="mobile phone" required/>
        </div>
        <div class="col-xs-3">
            <sui-text-field placeholder="### - #### - ####" max-length="100" default mask="full-phone"/>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data() {return {
        pageName : ""
    }}
}
</script>